import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const createMagazine = async (magazineData) => {
  const response = await axios.post(`${API_URL}/magazines`, magazineData);
  return response.data;
};

export const getMagazines = async () => {
  const response = await axios.get(`${API_URL}/magazines`);
  return response.data;
};

export const updateMagazine = async (id, magazineData) => {
  const response = await axios.put(`${API_URL}/magazines/${id}`, magazineData);
  return response.data;
};

export const deleteMagazine = async (id) => {
  const response = await axios.delete(`${API_URL}/magazines/${id}`);
  return response.data;
}; 